import {
  FETCH_COMPANY_REQUESTED,
  FETCH_COMPANY_SUCCEEDED,
  FETCH_COMPANY_FAILED,
  UPDATE_COMPANY_REQUESTED,
  UPDATE_COMPANY_SUCCEEDED,
  UPDATE_COMPANY_FAILED,
  FETCH_MEMBERS_FAILED,
  FETCH_MEMBERS_REQUESTED,
  FETCH_MEMBERS_SUCCEEDED,
  REMOVE_MEMBERS_FAILED,
  REMOVE_MEMBERS_REQUESTED,
  REMOVE_MEMBERS_SUCCEEDED,
  UPDATE_MEMBER_FAILED,
  UPDATE_MEMBER_REQUESTED,
  UPDATE_MEMBER_SUCCEEDED,
  ADD_CLIENT,
  UPDATE_MEMBER_LIST, UPDATE_CLIENT,
} from './actionTypes';


export function fetchCompanyRequested() {
  return {
    type: FETCH_COMPANY_REQUESTED,
  };
}

export function fetchCompanySucceeded(company) {
  return {
    type: FETCH_COMPANY_SUCCEEDED,
    payload: {
      company,
    },
  };
}

export function fetchCompanyFailed() {
  return {
    type: FETCH_COMPANY_FAILED,
  };
}

export function updateCompanyRequested(companyNewInfo) {
  return {
    type: UPDATE_COMPANY_REQUESTED,
    payload: {
      companyUpdate: companyNewInfo,
    },
  };
}

export function updateCompanySucceeded(companyInfo) {
  return {
    type: UPDATE_COMPANY_SUCCEEDED,
    payload: {
      companyUpdate: companyInfo,
    },
  };
}

export function updateCompanyFailed() {
  return {
    type: UPDATE_COMPANY_FAILED,
  };
}

export function fetchMembersRequested() {
  return {
    type: FETCH_MEMBERS_REQUESTED,
  };
}

export function fetchMembersSucceeded(membersList) {
  return {
    type: FETCH_MEMBERS_SUCCEEDED,
    payload: {
      members: membersList,
    },
  };
}

export function fetchMembersFailed() {
  return {
    type: FETCH_MEMBERS_FAILED,
  };
}

export function updateMemberRequested(memberUpdate) {
  return {
    type: UPDATE_MEMBER_REQUESTED,
    payload: {
      memberUpdate,
    },
  };
}

export function updateMemberSucceeded(memberUpdate) {
  return {
    type: UPDATE_MEMBER_SUCCEEDED,
    payload: {
      memberUpdate,
    },
  };
}

export function updateMemberFailed() {
  return {
    type: UPDATE_MEMBER_FAILED,
  };
}

export function removeMembersRequested(membersList) {
  return {
    type: REMOVE_MEMBERS_REQUESTED,
    payload: {
      membersList,
    },
  };
}

export function removeMembersSucceeded(membersList) {
  return {
    type: REMOVE_MEMBERS_SUCCEEDED,
    payload: {
      membersList,
    },
  };
}

export function removeMembersFailed() {
  return {
    type: REMOVE_MEMBERS_FAILED,
  };
}

export function addClient(client) {
  return {
    type: ADD_CLIENT,
    payload: {
      client,
    },
  };
}

export function updateMemberList(membersUpdate) {
  return {
    type: UPDATE_MEMBER_LIST,
    payload: {
      membersUpdate,
    },
  };
}

export function updateClient(clientId, update) {
  return {
    type: UPDATE_CLIENT,
    payload: {
      clientId,
      update,
    },
  };
}



// WEBPACK FOOTER //
// ./src/services/company/action.js